/**
 * StandardOfferCapChips — the Standard editor's bank offer-cap chips, shown
 * only for a tracker whose offers have bank caps. The editor is the
 * Voluum-shaped one, so the chips read Voluum's caps; Tres Commas (same offer
 * ids as Voluum) gets none rather than Voluum's.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { PathOfferCapChips } from '@/features/offer-caps';
import { useFlowTracker, useDrawerProfile } from '@/features/flow-optimizer/tracker';

export const StandardOfferCapChips: FC<{ offerIds: string[] }> = ({ offerIds }) => {
  const { offerCaps } = useDrawerProfile();
  const tracker = useFlowTracker();
  return offerCaps ? (
    <PathOfferCapChips platform={tracker ?? 'voluum'} offerIds={offerIds} />
  ) : null;
};

export default StandardOfferCapChips;
